import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import modalsComponents from '../modals';

import global from '../../config/global';
import storeActions from '../../store/actions';
import onboardingServices from '../../services/onboarding';
import common from '../../utils/common';

function Onboarding(props) {
  const {
    PlanNoticeModal,
    WelcomeModal,
    WelcomeBusinessModal,
    OnboardingModal,
    GetExtensionModal,
    EnterpriseInvitationsModal,
    SaleBlackFridayModal
  } = modalsComponents

  const {
    className = 'onboarding'
  } = props;

  const teams = useSelector((state) => state.enterprise.teams);
  const userInfo = useSelector((state) => state.auth.userInfo);
  const plan = useSelector((state) => state.payment.plan);
  const reloadOnboarding = useSelector((state) => state.onboarding.reloadOnboarding);

  const isEnterpriseAdmin = useMemo(() => {
    if (teams?.length > 0) {
      return teams[0]?.role?.includes('admin') && common.isEnterpriseMember()
    }
    return false
  }, [teams, userInfo])

  useEffect(() => {
    featOnboarding();
  }, [reloadOnboarding, isEnterpriseAdmin])

  const featOnboarding = async () => {
    onboardingServices.get_onboarding().then((response) => {
      global.store.dispatch(storeActions.updateOnboardingProcess(response))
      global.store.dispatch(storeActions.updateTutorialProcess(response.tutorial_process || []))
      global.store.dispatch(storeActions.updateWelcomeVisible(!response.welcome))
      global.store.dispatch(storeActions.updateShowTutorial(!response.tutorial))
      global.store.dispatch(storeActions.updateWelcomeBusinessVisible(isEnterpriseAdmin && !response.vault_to_dashboard))
    })
  }

  return (
    <div className={`${className}`}>
      <PlanNoticeModal />
      <WelcomeModal />
      <WelcomeBusinessModal />
      <OnboardingModal />
      <GetExtensionModal />
      <EnterpriseInvitationsModal />
      {
        plan && <SaleBlackFridayModal />
      }
    </div>
  );
}

export default Onboarding;
